<template>
	<v-navigation-drawer
		v-model="$root.drawer"
		:mini-variant.sync="mini"
		mini-variant-width="60"
		app
	>
		<v-list-item v-shortkey.push="['alt']" @shortkey="switchShowAtalhos">
			<v-list-item-icon>
				<v-icon>mdi-newspaper</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title class="title"> Consulta de </v-list-item-title>
				<v-list-item-title class="title"> Emendas </v-list-item-title>
				<v-list-item-title class="title"> Parlamentares </v-list-item-title>
				<!-- <v-list-item-subtitle class="text-8">
					Consulta de Emendas Parlamentares
				</v-list-item-subtitle> -->
			</v-list-item-content>
		</v-list-item>

		<v-divider></v-divider>
		<!-- <v-list v-if="$root.usuarioLogado">
			<v-list-item>
				<v-list-item-avatar :color="colorFromName($root.usuarioLogado.nome)">
					<span class="white--text headline">{{
						iniciais($root.usuarioLogado.nome)
					}}</span>v
				</v-list-item-avatar>

				<v-list-item-content>
					<v-list-item-title
						>{{ $root.usuarioLogado.nome.split(' ')[0] }}
					</v-list-item-title>
					<v-list-item-subtitle class="text-8">
						{{
							$root.usuarioLogado.nome
								.split(' ')
								.slice(1)
								.join(' ')
						}}
					</v-list-item-subtitle>
					<v-list-item-subtitle class="text-8"> </v-list-item-subtitle>
				</v-list-item-content>

				<v-list-item-action>
					<v-btn icon @click="logout" data-toggle="tooltip" title="Sair do Sistema">
						<v-icon hint="Sair do Sistema" color="grey lighten-1">mdi-exit-to-app</v-icon>
					</v-btn>
				</v-list-item-action>
			</v-list-item>
		</v-list> -->
		<div
			class="secretaria"
			v-if="$root.usuarioLogado && !temFuncao('EMENDA_LISTAR_TODAS')"
		>
			<v-divider></v-divider>
			<template v-if="$root.usuarioLogado.secretaria">
				<span class="sigla">{{ $root.usuarioLogado.secretaria.sigla }}</span> -
				{{ $root.usuarioLogado.secretaria.nome }}
			</template>
			<template v-else>
				<span class="sem-secretaria">
					Usuário não possuí secretaria vinculada
				</span>
			</template>
		</div>
		<v-divider></v-divider>

		<v-list>
			<!-- <v-navigation-item
				path="/"
				:shortkey="['alt', 'i']"
				icon="mdi-view-dashboard"
				title="Início"
			/> -->

			<v-navigation-item
				path="/emendas"
				:shortkey="['alt', 'e']"
				iconColor="blue"
				icon="mdi-cash-lock"
				title="Emendas"
			/>

			<v-navigation-item
				path="/paineis"
				:shortkey="['alt', 'e']"
				iconColor="green"
				icon="mdi-table"
				title="Painéis"
			/>

			<v-navigation-item				
				path="/painelEstadual"
				:shortkey="['alt', 's']"
				iconColor="orange"
				icon="mdi-tab"
				title="Emendas Estaduais"
			/>

			<v-navigation-item
				path="/painelFederal"
				:shortkey="['alt', 'f']"
				iconColor="purple"
				icon="mdi-tab-plus"
				title="Emendas Federais"
			/>
		</v-list>

		<v-divider></v-divider>

		<!-- <v-list>
			<v-col class="pt-0 pb-0" cols="12">											
				<v-select
					v-model="anoExercicio"
					:items="anoExercicioItems"
					label="Ano de Exercício"
					item-text="anoExercicio"
					item-value="anoExercicio"
					no-data-text="Não existem anos cadastrados"
					return-object
				/>
			</v-col>
		</v-list> -->

		<template v-slot:append>
			<div
				class="pa-2 d-none d-lg-block"
				v-if="!mini"
				style="padding-bottom: 0 !important"
			>
				<v-btn @click.stop="mini = !mini" text block>
					Recolher Menu <v-icon color="grey lighten-1">mdi-chevron-left</v-icon>
				</v-btn>
			</div>
			<div
				class="pa-2 d-none d-lg-block"
				v-if="mini"
				style="padding-bottom: 0 !important"
			>
				<v-btn icon @click.stop="mini = !mini">
					<v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
				</v-btn>
			</div>

			<!-- <div class="pa-2 d-none d-lg-block" v-if="!mini" style="padding-top: 0 !important">
				<v-btn @click.stop="logout" text block>
					Sair do Sistema <v-icon color="grey lighten-1">mdi-exit-to-app</v-icon>
				</v-btn>
			</div> -->
			<div
				class="pa-2 d-none d-lg-block"
				v-if="mini"
				style="padding-top: 0 !important"
			>
				<v-btn icon @click.stop="logout">
					<v-icon color="grey lighten-1">mdi-exit-to-app</v-icon>
				</v-btn>
			</div>
		</template>
	</v-navigation-drawer>
</template>

<script>
import VNavigationItem from '@/components/NavigationItem.vue';

export default {

	components: { VNavigationItem },

	data() {
		return {
			mini: false,
			anoExercicioItems: [],
			anoExercicio: null,
			//linkEmendasEstaduais: null,
			//linkEmendasFederais: null,
		};
	},

	async created() {
		this.fetchAnos();
	},

	watch: {
		anoExercicio() {
			this.$root.anoSelecionado = this.anoExercicio.anoExercicio;
			localStorage.setItem(
				'anoSelecionado',
				JSON.stringify(this.anoExercicio.anoExercicio)
			);
			this.$router.push('/emendas');
		},
	},

	methods: {
		irPara(rota) {
			if (this.$route.path !== rota) this.$router.push(rota);
		},
		switchShowAtalhos() {
			this.$root.showAtalhos = !this.$root.showAtalhos;
		},
		iniciais(nome) {
			let arrNome = nome.split(' ');
			return arrNome[0][0] + arrNome[arrNome.length - 1][0];
		},
		colorFromName(name) {
			let firstCharCode = name.toUpperCase().charCodeAt(0) - 65;
			let hue = (firstCharCode * 360) / 26;

			return `hsl(${hue}, 80%, 50%)`;
		},
		async logout() {
			this.$root.colorHeader = null;
			this.$root.titleHeader = null;

			await this.$fetch.delete('permisys');
			localStorage.removeItem('usuarioLogado');
			this.$router.push('/login');
			this.$emit('close-drawer');
		},
		temFuncao() {
			// return (
			// 	this.$root.usuarioLogado &&
			// 	this.$root.usuarioLogado.funcoes &&
			// 	this.$root.usuarioLogado.funcoes.includes(fn)
			// );
			return true;
		},

		fetchAnos() {
			var year = new Date().getFullYear();

			for (let index = year - 5; index <= year + 1; index++) {
				this.anoExercicioItems.push({ anoExercicio: index });
			}

			this.anoExercicio = this.anoExercicioItems.find(
				(e) => e.anoExercicio == year
			);
		},

	},
};
</script>

<style scoped>
.text-8 {
	font-size: 13px;
}

.secretaria {
	background: rgb(255, 255, 255);
	background: linear-gradient(
		180deg,
		rgba(230, 230, 230, 1) 0%,
		rgba(250, 250, 250, 1) 15%,
		rgba(255, 255, 255, 1) 20%,
		rgba(255, 255, 255, 1) 80%,
		rgba(250, 250, 250, 1) 85%,
		rgba(230, 230, 230, 1) 100%
	);

	text-align: center;
	font-size: 70%;
}
.secretaria > .sigla {
	font-weight: bold;
}

.secretaria > .sem-secretaria {
	font-weight: bold;
	font-style: italic;
	color: #999;
}
</style>
